import * as React from 'react';
import cn from 'classnames';

import WithBorder from 'shared/newComponents/WithBorder';
import { PopupTrigger } from 'shared/entities/components/Popup';
import { SelectorTriggerSize } from 'shared/newEntities/components/Selector';

import styles from './Trigger.modules.scss';

type Props = {
  isSelectorOpened: boolean;
  isError: boolean;
  disabled?: boolean;
  withoutBorder?: boolean;
  children: PopupTrigger;
  size?: SelectorTriggerSize;
  triggerClassName?: string;
};

const Trigger: React.FC<Props> = ({
  isSelectorOpened,
  isError,
  disabled,
  withoutBorder,
  children,
  size = SelectorTriggerSize.xl,
  triggerClassName
}) => {
  const content = (
    <div
      styleName="trigger"
      className={cn(styles[`trigger_${size}`], triggerClassName)}
    >
      {React.isValidElement(children) ? (
        <>{children}</>
      ) : (
        children(isSelectorOpened)
      )}
    </div>
  );

  if (withoutBorder) {
    return content;
  }

  return (
    <WithBorder focus={isSelectorOpened} error={isError} disabled={disabled}>
      {content}
    </WithBorder>
  );
};

export default Trigger;
